var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24983 2.80001C7.18688 2.80001 7.1276 2.82965 7.08983 2.88001L5.34983 5.20001H18.1498L16.4098 2.88001C16.3721 2.82965 16.3128 2.80001 16.2498 2.80001H7.24983ZM19.6275 5.25844L19.9898 4.98668C20.3533 5.47135 20.5498 6.06084 20.5498 6.66668V19C20.5498 20.5464 19.2962 21.8 17.7498 21.8H5.74983C4.20343 21.8 2.94983 20.5464 2.94983 19V6.66668C2.94983 6.06084 3.14633 5.47135 3.50983 4.98668L5.80983 1.92001L6.44983 2.40001L5.80983 1.92001C6.14977 1.46676 6.68327 1.20001 7.24983 1.20001H16.2498C16.8164 1.20001 17.3499 1.46676 17.6898 1.92001L19.9898 4.98668L19.6275 5.25844ZM18.9498 6.80001H4.54983V19C4.54983 19.6628 5.08709 20.2 5.74983 20.2H17.7498C18.4126 20.2 18.9498 19.6628 18.9498 19V6.80001ZM8.74983 9.20001C9.19166 9.20001 9.54983 9.55818 9.54983 10C9.54983 11.215 10.5348 12.2 11.7498 12.2C12.9649 12.2 13.9498 11.215 13.9498 10C13.9498 9.55818 14.308 9.20001 14.7498 9.20001C15.1917 9.20001 15.5498 9.55818 15.5498 10C15.5498 12.0987 13.8485 13.8 11.7498 13.8C9.65115 13.8 7.94983 12.0987 7.94983 10C7.94983 9.55818 8.308 9.20001 8.74983 9.20001Z",
    fill: "#111114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.cf54db902d89b3959e972a82448b6060.svg";
export { ForwardRef as ReactComponent };